import Loadable from '../../components/loadable';

const AttendanceWidget = Loadable({
  loader: () => import('../../pages/dashboard/attendance/attendance_widget'),
  type: 'block',
});

angular.module('gym').value('AttendanceWidget', AttendanceWidget);
